import { useEffect, useState } from 'react';
import { Grid } from 'antd';

export function useScreenSize() {
  const screens = Grid.useBreakpoint();

  const [isSmall, setIsSmall] = useState(!screens.md && !screens.lg && !screens.xl && !screens.xxl);

  useEffect(() => {
    setIsSmall(!screens.md && !screens.lg && !screens.xl && !screens.xxl);
  }, [screens]);

  return isSmall;
}
